const promotionsData = [
    {
      id: 1,
      name: "Promotion ",
      description: "Quick sale,",
    },
    {
      id: 2,
      name: "Black friday deals",
      description: "Enjoy your shopping online with 50% discounted goods & gifts",
    },
  ];
  
  export default promotionsData;
  